<template>
  <div v-if="stats" class="mb-6">
    <div class="flex flex-wrap gap-3">
      <!-- Seller ratings button -->
      <button
        @click="
          $emit('change-role', 'seller');
          $emit('change-filter', 'all');
        "
        class="px-5 py-3 rounded-lg text-white font-medium transition-colors flex items-center"
        :class="
          userRole === 'seller'
            ? 'bg-gray-700 hover:bg-gray-600'
            : 'bg-gray-800 hover:bg-gray-700'
        "
      >
        <span>Kao prodavac</span>
        <span class="inline-flex items-center ml-3 space-x-2">
          <!-- Thumbs up -->
          <span
            @click.stop="
              $emit('change-role', 'seller');
              $emit('change-filter', 'positive');
            "
            class="inline-flex items-center px-2 py-1 rounded"
            :class="{
              'bg-green-800 text-green-200':
                userRole === 'seller' && activeFilter === 'positive',
              'hover:bg-gray-600': !(
                userRole === 'seller' && activeFilter === 'positive'
              ),
            }"
          >
            <span class="mr-1">👍</span>
            <span>{{ stats.seller.likes }}</span>
          </span>

          <!-- Thumbs down -->
          <span
            @click.stop="
              $emit('change-role', 'seller');
              $emit('change-filter', 'negative');
            "
            class="inline-flex items-center px-2 py-1 rounded"
            :class="{
              'bg-red-800 text-red-200':
                userRole === 'seller' && activeFilter === 'negative',
              'hover:bg-gray-600': !(
                userRole === 'seller' && activeFilter === 'negative'
              ),
            }"
          >
            <span class="mr-1">👎</span>
            <span>{{ stats.seller.dislikes }}</span>
          </span>
        </span>
      </button>

      <!-- Buyer ratings button -->
      <button
        @click="
          $emit('change-role', 'buyer');
          $emit('change-filter', 'all');
        "
        class="px-5 py-3 rounded-lg text-white font-medium transition-colors flex items-center"
        :class="
          userRole === 'buyer'
            ? 'bg-gray-700 hover:bg-gray-600'
            : 'bg-gray-800 hover:bg-gray-700'
        "
      >
        <span>Kao kupac</span>
        <span class="inline-flex items-center ml-3 space-x-2">
          <!-- Thumbs up -->
          <span
            @click.stop="
              $emit('change-role', 'buyer');
              $emit('change-filter', 'positive');
            "
            class="inline-flex items-center px-2 py-1 rounded"
            :class="{
              'bg-green-800 text-green-200':
                userRole === 'buyer' && activeFilter === 'positive',
              'hover:bg-gray-600': !(
                userRole === 'buyer' && activeFilter === 'positive'
              ),
            }"
          >
            <span class="mr-1">👍</span>
            <span>{{ stats.buyer.likes }}</span>
          </span>

          <!-- Thumbs down -->
          <span
            @click.stop="
              $emit('change-role', 'buyer');
              $emit('change-filter', 'negative');
            "
            class="inline-flex items-center px-2 py-1 rounded"
            :class="{
              'bg-red-800 text-red-200':
                userRole === 'buyer' && activeFilter === 'negative',
              'hover:bg-gray-600': !(
                userRole === 'buyer' && activeFilter === 'negative'
              ),
            }"
          >
            <span class="mr-1">👎</span>
            <span>{{ stats.buyer.dislikes }}</span>
          </span>
        </span>
      </button>

      <!-- All ratings button (only visible when a filter is active) -->
      <button
        v-if="activeFilter !== 'all'"
        @click="$emit('change-filter', 'all')"
        class="px-5 py-3 rounded-lg bg-blue-600 hover:bg-blue-500 text-white font-medium transition-colors"
      >
        Prikaži sve ocene
      </button>
    </div>

    <!-- Filter indicator -->
    <div
      v-if="activeFilter !== 'all'"
      class="mt-3 px-3 py-2 bg-gray-800 rounded-lg text-sm text-gray-300"
    >
      Prikazuju se samo
      <span
        class="font-medium"
        :class="activeFilter === 'positive' ? 'text-green-400' : 'text-red-400'"
      >
        {{ activeFilter === 'positive' ? 'pozitivne' : 'negativne' }}
      </span>
      ocene kao
      <span class="font-medium text-blue-400">
        {{ userRole === 'seller' ? 'prodavac' : 'kupac' }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

interface RatingStats {
  seller: {
    likes: number;
    dislikes: number;
  };
  buyer: {
    likes: number;
    dislikes: number;
  };
}

export default defineComponent({
  name: 'ProfileRatingStats',
  props: {
    stats: {
      type: Object as PropType<RatingStats>,
      required: true,
    },
    userRole: {
      type: String as PropType<'seller' | 'buyer'>,
      required: true,
    },
    activeFilter: {
      type: String as PropType<'all' | 'positive' | 'negative'>,
      default: 'all',
    },
  },
  emits: ['change-role', 'change-filter'],
});
</script>
